"use client";

import { useEffect, useRef } from "react";

export const Think = () => {
  const styleRef = useRef<HTMLStyleElement | null>(null);

  useEffect(() => {
    // Create and inject keyframe animation
    const style = document.createElement('style');
    style.textContent = `
      @keyframes think-pulse {
        0%, 100% {
          transform: scale(1);
          opacity: 0.6;
        }
        50% {
          transform: scale(1.5);
          opacity: 1;
        }
      }
      
      .think-animation {
        animation: think-pulse 1.5s ease-in-out infinite;
      }
    `;
    document.head.appendChild(style);
    styleRef.current = style;

    return () => {
      if (styleRef.current && document.head.contains(styleRef.current)) {
        document.head.removeChild(styleRef.current);
      }
    };
  }, []);

  return (
    <div className="h-2 w-2 rounded-full bg-primary think-animation" />
  );
};
